/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsFamilySettingsAdminRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsFamilySettingsAdminResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsFamilySettingsAdmin = (request: GetSavingsFamilySettingsAdminRequest, options?: CashRequestOptions) => post<GetSavingsFamilySettingsAdminRequest, GetSavingsFamilySettingsAdminResponse>("/2.0/cash/get-savings-family-settings-admin", request, {...options, rejectOnError: true })